/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable */ import clsx from 'clsx'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import * as Yup from 'yup'
// import { useUser } from '../../../../_helper/userHooks/userHook'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { storeProviderCodeInLocalStorage, storeTokenInLocalStorage } from '../../../../_helper/userHooks/common'
const initialValues = {
  providerCode: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/
export function ProviderCode() {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState('')

  const history = useHistory()
  const location = useLocation()
  const savedProviderCode = localStorage.getItem('providerCode') || ''; 
  useEffect(() => {
    ;(async () => {
      let code: any = location.search.split('=')

      if (code?.length >= 2) {
        code = [code[1]]
      }

      if (!code || !code[0]) {
        history.push('/auth/login') // Redirect if no code is present
        return
      }

      const myHeaders = new Headers()
      myHeaders.set('Content-Type', 'application/x-www-form-urlencoded')

      // Removed the invalid header
      // myHeaders.set('', ''); // This line is causing the error

      const urlencoded = new URLSearchParams()
      urlencoded.set('grant_type', 'authorization_code')
      urlencoded.set('client_id', process.env.REACT_APP_COGNITO_CLIENT_ID)
      urlencoded.set('client_secret', process.env.REACT_APP_COGNITO_CLIENT_SECRET)
      urlencoded.set('code', code[0])
      urlencoded.set('redirect_uri', process.env.NODE_ENV === 'development' ? 
        process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN_LOCAL : 
        process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN)

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }
   try {
      const response = await fetch(
        'https://trumemo.auth.us-east-1.amazoncognito.com/oauth2/token',
        requestOptions as any
      )
      const result = await response.json()
      if (!result.access_token) {
        history.push('/auth/login')
        return
      }

      setResult(result.access_token)
    } catch (error) {
      console.error(error)
      history.push('/auth/login')
    }
  })()
}, [location, history])

const checkMFAStatus = async (token) => {
  try {
    // Step 1: Check if admin has enforced MFA for users
    const adminMfaResponse = await axios.get('/settings/mfa', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    if (adminMfaResponse?.data && adminMfaResponse?.data?.mfaEnabled) {
    // Step 2: Admin has enforced MFA, now check if user has activated their individual MFA
      const userMfaResponse = await axios.post('/users/mfa-enabled',{}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    // Check if userMfaResponse.data is empty object (user hasn't activated MFA)
       if (!userMfaResponse.data || Object.keys(userMfaResponse.data).length === 0) {
         // Step 3: User hasn't activated their individual MFA, redirect to QR code page
         history.push('/auth/login-mfa', {
           loginData: {
             providerCode: savedProviderCode,
             token: token
           }
         })
       } else {
        history.push('/dashboard')
        window.location.reload()
       }
    } else {
      await storeTokenInLocalStorage(token)
      history.push('/dashboard')
      window.location.reload()
     }
    // If admin hasn't enforced MFA, users can proceed to dashboard
  } catch (error) {
    console.error('MFA status check error:', error)
    // If we can't check MFA status, continue with normal flow
  }
};

  useEffect(() => {
    const handleStorageChange = () => {
      if (localStorage.getItem('authToken') && localStorage.getItem('providerCode')) {
        checkMFAStatus(localStorage.getItem('authToken'))
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const formik = useFormik({
     initialValues: {
    providerCode: savedProviderCode, 
  },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: Yup.object({
      providerCode: Yup.string().required('Provider code is required'),
    }),
    onSubmit: async (values, { setStatus, setSubmitting, setFieldError }) => {
      try {
        const response = await axios.post(`/users/login`, {
          accessToken: result,
          providerCode: values.providerCode,
        });
  
        if (!response.data?.token) {
          throw new Error('Invalid provider code. Please try again.');
        }
  
        const currentProviderCode = localStorage.getItem('providerCode');
        if (currentProviderCode !== values.providerCode) {
          await storeProviderCodeInLocalStorage(values.providerCode);
        }
  
        const storedProviderCode = localStorage.getItem('providerCode');
  
        if (response?.data?.token && storedProviderCode) {
          checkMFAStatus(response?.data?.token)
        }
      } catch (error) {
        // Show toast error if provider code doesn't exist or is invalid
        toast.error(error.response?.data?.message || error.message || 'Something went wrong.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFieldError('providerCode', 'Invalid provider code');
      }

    },
  });
  

  return (
    <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'> 
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Enter your provider code</h1>
      </div>

      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Provider Code</label>
          </div>
        </div>
        <input
  placeholder='Provider Code'
  name='providerCode'
  type='text'
  autoComplete='on'
  {...formik.getFieldProps('providerCode')}
  className={clsx(
    'form-control form-control-lg form-control-solid',
    {
      'is-invalid': formik.touched.providerCode && formik.errors.providerCode, // Shows ❌ when invalid
    },
    {
      'is-valid': formik.touched.providerCode && !formik.errors.providerCode, // Shows ✅ when valid
    }
  )}
/>

        {formik.touched.providerCode && formik.errors.providerCode && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert' className='text-danger'>
                {formik.errors.providerCode}
              </span>
            </div>
          </div>
        )}
      </div>

      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
        >
          {!loading && <span className='indicator-label'>Submit</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      <div className='d-flex justify-content-start'>
      <Link to='/auth/login' className='btn btn-link text-muted'>
        ← Back to Sign In
      </Link>
    </div>

      {error != '' ? (
        <div style={{color: 'red', display: 'flex', justifyContent: 'center'}}>{error}</div>
      ) : (
        ''
      )}
      {/* end::Action */}
    </form>
    </div>
  )
}
